var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Multiselect',{attrs:{"options":_vm.options,"track-by":_vm.trackBy,"label":_vm.label,"selectLabel":_vm.selectLabel,"deselectLabel":_vm.deselectLabel},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }